import { makeEnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { TasksCountService } from '../services/tasks-count.service';
import { newTasksCountPollingEffect } from '../store/task.effects';
import { taskReducer } from '../store/task.reducer';

export function provideNewTasksCountPolling() {
  return makeEnvironmentProviders([
    provideState({ name: 'task', reducer: taskReducer }),
    provideEffects({ newTasksCountPollingEffect }),
    TasksCountService,
  ]);
}
